import React from "react";
import TwilioVideo from "twilio-video";
import { connect } from 'react-redux';
import { logUI } from '../../api/andyliticsApi';
import * as Tools from '../../helpers/Tools';
import MiniSpinner from '../common/MiniSpinner';

const NETWORK_TEST_URL = "https://networktest.twilio.com/?region=us1";

function ensureMediaPermissions() {
    return navigator.mediaDevices
        .getUserMedia({ audio: true, video: true })
        .then((mediaStream) =>
            mediaStream.getTracks().forEach((track) => track.stop())
        )
        .catch((err) => {
            throw new Error(err);
        });
}

function getDevices() {
    return navigator.mediaDevices.enumerateDevices();
}

let currentStream;


class PreVisitTest extends React.Component {
    constructor(props) {
        super(props);
        this.ios = Tools.isIos();
        this.config = {
            userAction: {
                1: [
                    { id: "1", buttonText: "YES, PLEASE", activityCode: "Yes.Clicked", stepName: "GetStarted" },
                    { id: "2", buttonText: "NO, THANKS", activityCode: "No.Clicked", stepName: "GetStarted" }
                ],
                3: [{ id: "3", buttonText: "EXIT", activityCode: "Exit.Clicked", stepName: "BrowserNotSupported" }],
                4: [{ id: "4", buttonText: "PLAY", activityCode: "Play.Clicked", stepName: "TestSpeaker" }],
                5: [
                    { id: "5", buttonText: "YES", activityCode: "Yes.Clicked", stepName: "HearingSpeakerSound" },
                    { id: "6", buttonText: "NO", activityCode: "No.Clicked", stepName: "HearingSpeakerSound" }
                ],
                6: [{ id: "7", buttonText: "OKAY", activityCode: "Okay.Clicked", stepName: "YesICanHear" }],
                7: [
                    { id: "8", buttonText: "YES", activityCode: "Yes.Clicked", stepName: "DoYouHaveSpeakers" },
                    { id: "9", buttonText: "NO", activityCode: "No.Clicked", stepName: "DoYouHaveSpeakers" }
                ],
                8: [
                    { id: "10", buttonText: "YES", activityCode: "Yes.Clicked", stepName: "AreYourSpeakersTurnedOn" },
                    { id: "11", buttonText: "NO", activityCode: "No.Clicked", stepName: "AreYourSpeakersTurnedOn" }
                ],
                9: [
                    { id: "12", buttonText: "YES", activityCode: "Yes.Clicked", stepName: "AreYourSpeakersMuted" },
                    { id: "13", buttonText: "NO", activityCode: "No.Clicked", stepName: "AreYourSpeakersMuted" }
                ],
                10: [
                    { id: "14", buttonText: "YES", activityCode: "Yes.Clicked", stepName: "UnMuteSpeakersDoYouHearSoundNow" },
                    { id: "15", buttonText: "NO", activityCode: "No.Clicked", stepName: "UnMuteSpeakersDoYouHearSoundNow" }
                ],
                11: [
                    { id: "16", buttonText: "YES", activityCode: "Yes.Clicked", stepName: "IsVolumeTurnedUpOnSpeakers" },
                    { id: "17", buttonText: "NO", activityCode: "No.Clicked", stepName: "IsVolumeTurnedUpOnSpeakers" }
                ],
                12: [
                    { id: "18", buttonText: "YES", activityCode: "Yes.Clicked", stepName: "DoYouHaveHeadPhones" },
                    { id: "19", buttonText: "NO", activityCode: "No.Clicked", stepName: "DoYouHaveHeadPhones" }
                ],
                13: [
                    { id: "20", buttonText: "PLAY SOUND" },
                    { id: "21", buttonText: "QUIT" }
                ],
                14: [{ id: "22", buttonText: "OKAY", activityCode: "Okay.Clicked", stepName: "NeedPermissionToAccessWebCamAndMic" }],
                15: [
                    { id: "23", buttonText: "SKIP" },
                    { id: "24", buttonText: "EXIT" }
                ],
                16: [
                    { id: "25", buttonText: "YES" },
                    { id: "26", buttonText: "NO" }
                ],
                17: [
                    { id: "27", buttonText: "SKIP" },
                    { id: "28", buttonText: "EXIT" }
                ],
                18: [{ id: "29", buttonText: "LISTENING..", disabled: true }],
                19: [{ id: "30", buttonText: "OKAY", activityCode: "Okay.Clicked", stepName: "LetsCheckWebCamAndMic" }],
                21: [{ id: "31", buttonText: "TRY AGAIN" }],
                22: [{ id: "32", buttonText: "NETWORK TEST", aTag: true, url: NETWORK_TEST_URL, activityCode: "NetworkTest.Clicked", stepName: "AllSetForCall" },
                { id: "37", buttonText: "EXIT", activityCode: "Exit.Clicked", stepName: "AllSetForCall" }],
                23: [
                    { id: "33", buttonText: "YES", activityCode: "Yes.Clicked", stepName: "DoYouSeeVideoFeed" },
                    { id: "34", buttonText: "NO", activityCode: "No.Clicked", stepName: "DoYouSeeVideoFeed" }
                ],
                25: [
                    { id: "35", buttonText: "DONE!", activityCode: "Done.Clicked", stepName: "NoVideoFeed.WrongCamera.ChangeCamera" },
                    { id: "36", buttonText: "SKIP", activityCode: "Skip.Clicked", stepName: "NoVideoFeed.WrongCamera.ChangeCamera" }                    
                ],
                26: [
                    { id: "38", buttonText: "OKAY", activityCode: "Okay.Clicked", stepName: "NoVideoFeed.JustSpinningWheel.RestartDevice" },
                    { id: "39", buttonText: "SKIP", activityCode: "Skip.Clicked", stepName: "NoVideoFeed.JustSpinningWheel.RestartDevice" }
                ],
                27: [
                    { id: "40", buttonText: "I'll remove it", activityCode: "IWillRemoveIt.Clicked", stepName: "NoVideoFeed.BlankScreen.SomethingCovering" },
                    { id: "41", buttonText: "Nothing there", activityCode: "NothingThere.Clicked", stepName: "NoVideoFeed.BlankScreen.SomethingCovering" }
                ],
                28: [
                    { id: "42", buttonText: "OKAY", activityCode: "Okay.Clicked", stepName: "NoVideoFeed.None.RestartDevice" },
                    { id: "43", buttonText: "SKIP", activityCode: "Skip.Clicked", stepName: "NoVideoFeed.None.RestartDevice" }
                ],
                31: [
                    { id: "50", buttonText: "YES" }, //is mic turned on? yes
                    { id: "51", buttonText: "NO" }
                ],
                32: [
                    { id: "52", buttonText: "YES" }, //is it muted? yes
                    { id: "53", buttonText: "NO" }
                ],
                33: [
                    { id: "54", buttonText: "TRY AGAIN" }, //turn mic on and try again
                    { id: "55", buttonText: "EXIT" }
                ],
                34: [
                    { id: "56", buttonText: "TRY AGAIN" }, //unmute and try again
                    { id: "57", buttonText: "EXIT" }
                ],
                35: [{ id: "58", buttonText: "OKAY!" }],
                36: [
                    { id: "59", buttonText: "YES" },
                    { id: "60", buttonText: "NO" }
                ],
                37: [
                    { id: "61", buttonText: "YES" },
                    { id: "62", buttonText: "NO" }
                ],
                38: [
                    { id: "63", buttonText: "YES" },
                    { id: "64", buttonText: "NO" }
                ],
                39: [
                    { id: "65", buttonText: "YES" },
                    { id: "66", buttonText: "NO" }
                ],
                40: [
                    { id: "67", buttonText: "YES" },
                    { id: "68", buttonText: "NO" }
                ],
                41: [
                    { id: "45", buttonText: "OK, I'LL DO THAT!" }
                ],
                42: [
                    { id: "69", buttonText: "YES" },
                    { id: "70", buttonText: "NO" }
                ]
            },
            botResponse: {
                1: [
                    {
                        message:
                            "Let us make sure your system is ready for a BSWH call. Shall we get started?",
                        id: "msg-12"
                    }
                ],

                2: [{ message: "OK, bye!", id: "msg-21" }],
                3: [
                    {
                        message:
                            "Unfortunately, MyBSWHealth Video Visit requires features that your web browser doesn’t support.",
                        id: "msg-31"
                    },
                    {
                        message:
                            `You are using an unsupported browser. For the best video experience, try using ${this.ios ? "Safari" : "Chrome"}.`,
                        id: "msg-32"
                    }
                ],
                4: [
                    {
                        message:
                            "Alrighty, let's start by testing your speakers. Click Play!",
                        id: "msg-41"
                    }
                ],
                5: [{ message: "Do you hear the sound I'm playing?", id: "msg-51" }],
                6: [
                    {
                        message: "Super 😊! That means you will hear your provider.",
                        id: "msg-61"
                    }
                ],
                7: [{ message: "Hmm, do you have speakers ?", id: "msg-71" }],
                8: [{ message: "Are your speakers turned on?", id: "msg-81" }],
                9: [{ message: "Are your speakers muted?", id: "msg-91" }],
                10: [
                    {
                        message: "Ok unmute your speakers. Do you hear sound now?",
                        id: "msg-101"
                    }
                ],
                11: [
                    {
                        message: "Is the volume on your speakers turned up?",
                        id: "msg-111"
                    }
                ],
                12: [
                    { message: "Do you have headphones you can plug in?", id: "msg-121" }
                ],
                13: [
                    {
                        message:
                            "Unfortunately, a call is not possible unless your speakers are working 😩 Please get some speakers or headphones and try again.",
                        id: "msg-131"
                    }
                ],
                14: [
                    {
                        message:
                            "I'll need your permission to use your microphone and webcam. When prompted, click Allow. 🙏",
                        id: "msg-141"
                    }
                ],
                15: [
                    {
                        message: "Uh oh! 😟 Your browser does not detect a microphone.",
                        id: "msg-151"
                    },
                    {
                        message:
                            "Your provider won't be able to hear you. Can you please plug in a microphone and then restart your browser?",
                        id: "msg-152"
                    }
                ],
                16: [
                    {
                        message: "Uh oh! Your browser did not detect a webcam.",
                        id: "msg-161"
                    },
                    { message: "Do you have a webcam?", id: "msg-162" }
                ],
                17: [
                    {
                        message: "Plug in a webcam and then restart your web browser.",
                        id: "msg-171"
                    }
                ],
                18: [{ message: "Say something into your microphone?", id: "msg-181" }],
                19: [
                    {
                        message: "Okay, now let's check your microphone and webcam.",
                        id: "msg-191"
                    }
                ],
                20: [
                    {
                        message:
                            "Ok great, it looks like we can now access your microphone and camera!",
                        id: "msg-201"
                    },
                    { message: "Say something into your microphone?", id: "msg-202" }
                ],
                21: [
                    {
                        message: "Whoa, you denied access to your microphone/webcam!",
                        id: "msg-211"
                    },
                    {
                        message:
                            "In order for your microphone and webcam to work, you need to allow access.",
                        id: "msg-212"
                    }
                ],
                22: [
                    { message: "Woohoo, I hear you loud and clear! 📢🤪", id: "msg-221" },
                    {
                        message:
                            "Ok, time for the webcam! Do you see a video feed of yourself?",
                        id: "msg-222"
                    }
                ],
                23: [
                    {
                        message: "Alright! you are all set for a great video visit!",
                        id: "msg-231"
                    }
                ],
                24: [
                    {
                        select: true,
                        options: [
                            {
                                message: "It's the wrong camera",
                                type: "option",
                                id: "msg-241"
                            },
                            {
                                message: "No video, just a spinning wheel",
                                type: "option",
                                id: "msg-242"
                            },
                            {
                                message: "I just see a blank screen",
                                type: "option",
                                id: "msg-243"
                            },
                            { message: "None", type: "option", id: "msg-244" }
                        ]
                    }
                ],
                25: [
                    {
                        message:
                            "Ah, no problem! Click the camera icon in the browser address bar and select a different webcam.",
                        id: "msg-251"
                    }
                ],
                26: [
                    {
                        message: "Ok, that means other app might be using your camera. 😕",
                        id: "msg-261"
                    },
                    {
                        message: "Can you try restarting your device and coming back?",
                        id: "msg-262"
                    }
                ],
                27: [
                    {
                        message: "Hmm... 🤔 do you have something covering your camera?",
                        id: "msg-271"
                    }
                ],
                28: [
                    {
                        message: "Can you try restarting your device and coming back?",
                        id: "msg-281"
                    }
                ],
                31: [
                    { message: "I can't hear you 😭", id: "msg-311" },
                    { message: "Is your microphone turned on?", id: "msg-312" }
                ],
                32: [{ message: "Is it muted?", id: "msg-321" }],
                33: [
                    {
                        message: "Ok, turn it on and try again.",
                        id: "msg-331"
                    }
                ],
                34: [{ message: "Ok, unmute it and try again.", id: "msg-341" }],
                35: [
                    {
                        message:
                            " Hmm. Another app may be interfering 😕 Can you please restart your device and try again?",
                        id: "msg-351"
                    }
                ],
                36: [
                    {
                        message: "Turn on your speakers. Do you hear sound now?",
                        id: "msg-361"
                    }
                ],
                37: [
                    {
                        message: "Is the volume on your speakers turned up?",
                        id: "msg-371"
                    }
                ],
                38: [
                    {
                        message: "Ok...turn it up 😁 Do you hear sound now? ",
                        id: "msg-381"
                    }
                ],
                39: [{ message: "Do you hear sound now?", id: "msg-391" }],
                40: [{ message: "Is your device sound muted?", id: "msg-401" }],
                41: [{ message: "Hmm 😟. Let's try something more drastic: Please restart your device and come back, ok?", id: "msg-411" }],
                42: [{ message: "Ok, unmute your system sound. Do you hear sound now?", id: "msg-421" }]
            }
        };
        this.state = {
            botResponseId: 1,
            userActionId: 1,
            playing: false
        };
        this.audio = new Audio("/audio/videovisit-speakertest-2.mp3");
        this.onAudioPlayBackEnd = this.onAudioPlayBackEnd.bind(this);
    }

    componentDidMount() {
        if (this.audio) {
            this.audio.addEventListener('ended', this.onAudioPlayBackEnd);
        }
    }

    componentWillUnmount() {
        if (this.audio) {
            this.audio.removeEventListener('ended', this.onAudioPlayBackEnd);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { playing } = this.state;
        if (this.state.playing !== prevState.playing) {
            if (playing) {
                this.audio.currentTime = 0;
                this.audio.play();
            }
            else this.audio.pause();
        }
        if (
            this.state.userActionId === 18 &&
            prevState.userActionId !== this.state.userActionId
        ) {
            this.micTest = false;
            this.getUserMedia({ audio: true }, this.onMicSuccess, this.onMicError);
        }
        if (
            this.state.userActionId === 23 &&
            prevState.userActionId !== this.state.userActionId
        ) {
            this.getUserMedia(
                { video: true },
                this.onCameraSuccess,
                this.onCameraFailure
            );
        }
    }

    //Repeat audio play until user response.
    onAudioPlayBackEnd() {
        const { playing } = this.state;
        if (playing) {
            this.audio.currentTime = 0;
            this.audio.play();
        }
    }

    getUserMedia = (constraints, onSuccess, onError) => {
        if (typeof currentStream !== "undefined") {
            this.stopMediaTracks(currentStream);
        }
        if (navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
        }
    };
    onCameraSuccess = (stream) => {
        const video = document.getElementById("previsittest-video");
        if (video)
            video.srcObject = stream;
        currentStream = stream;
        logUI('MBHWeb.UI.PreVisitTest.onCameraSuccess', new Date(), Tools.getURLPath());
    };



    onCameraFailure = (err) => {
        const { message } = err;
        if (message && message.indexOf("NotFoundError") > -1)
            this.setState({
                botResponseId: 16,
                userActionId: 16
            });
        else if (message && message.indexOf("Permission") > -1)
            this.setState({
                botResponseId: 21,
                userActionId: 21
            });
        logUI('MBHWeb.UI.PreVisitTest.onCameraFailure', new Date(), Tools.getURLPath(), { "Error": err });
    };

    onMicSuccess = (stream) => {
        logUI('MBHWeb.UI.PreVisitTest.onMicSuccess', new Date(), Tools.getURLPath());
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        const context = new AudioContext();
        const analyser = context.createAnalyser();
        const source = context.createMediaStreamSource(stream);
        const processor = context.createScriptProcessor(1024, 1, 1);

        analyser.smoothingTimeConstant = 0.8;
        analyser.fftSize = 1024;

        source.connect(analyser);
        analyser.connect(processor);
        processor.connect(context.destination);

        processor.onaudioprocess = (e) => {
            var array = new Uint8Array(analyser.frequencyBinCount);
            analyser.getByteFrequencyData(array);
            var values = 0;

            var length = array.length;
            for (var i = 0; i < length; i++) {
                values += array[i];
            }

            var average = values / length;

            // colorPids(average);

            if (Math.round(average) > 30) {//increase the average frequency if mic need to listen and test louder sounds.
                if (!this.micTest) {
                    this.micTest = true;
                    this.setState({ botResponseId: 22, userActionId: 23 });
                }
            } else {
                if (this.micTest) clearTimeout(this.timerId);
                this.timerId = setTimeout(() => {
                    if (!this.micTest) {
                        this.micTest = true;
                        this.setState({ botResponseId: 31, userActionId: 31 });
                    }
                }, 5000);
            }
        };
        currentStream = stream;
    };

    onMicError = (err) => {
        const { message } = err;
        if (this.skipMic) {
            setTimeout(() => {
                this.setState({ botResponseId: 31, userActionId: 31 });
            }, 3000);
            this.skipMic = false;
        } else {
            if (message && message.indexOf("NotFoundError") > -1)
                this.setState({
                    botResponseId: 15,
                    userActionId: 15
                });
            else if (message && message.indexOf("Permission") > -1)
                this.setState({
                    botResponseId: 21,
                    userActionId: 21
                });
        }
        logUI('MBHWeb.UI.PreVisitTest.onMicError', new Date(), Tools.getURLPath(), { "Error": err });
    };

    togglePlay = () => {
        this.setState((prevState, props) => ({ playing: !prevState.playing }));
    };

    onUserAction = (action) => {
        const selectedAction = action.id;
        if (action.stepName && action.activityCode)
            logUI(`MBHWeb.UI.PreVisitTest.${action.stepName}.${action.activityCode}`, new Date(), Tools.getURLPath());
        if (selectedAction === "1") {
            const isSupported = TwilioVideo.isSupported ? true : false;
            this.setState({
                botResponseId: !isSupported ? 3 : 4,
                userActionId: !isSupported ? 3 : 4
            });
        } else if (selectedAction === "4" || selectedAction === "20") {
            //PLAY SOUND OR PLAY SOUND AGAIN

            this.setState({
                botResponseId: 5,
                userActionId: 5,
                playing: true
            });
        } else if (
            selectedAction === "5" ||
            selectedAction === "14" ||
            selectedAction === "59" ||
            selectedAction === "63" ||
            selectedAction === "65" ||
            selectedAction === "69"
        ) {
            //CAN HEAR SOUND

            this.setState({
                botResponseId: 6,
                userActionId: 6,
                playing: false
            });
        } else if (
            selectedAction === "6"
        ) {
            // CANNOT HEAR SOUND

            this.setState({
                botResponseId: 7,
                userActionId: 7,
                playing: false
            });
        } else if (selectedAction === "7") {
            // SPEAKER TEST SUCCESSFUL, CHECK IF DEVICES THERE
            getDevices()
                .then((devices) => {
                    const microphone = devices.filter(
                        (device) => device.kind === "audioinput"
                    );

                    const camera = devices.filter(
                        (device) => device.kind === "videoinput"
                    );

                    if (microphone.length > 0 && camera.length > 0) {
                        // BOTH CAMERA AND MIC ARE THERE.
                        this.setState({
                            botResponseId: 19,
                            userActionId: 19
                        });
                    } else if (microphone.length <= 0)
                        this.setState({
                            botResponseId: 15,
                            userActionId: 15
                        });
                    else if (camera.length <= 0)
                        this.setState({
                            botResponseId: 16,
                            userActionId: 16
                        });
                })
                .catch((err) => {
                    const { message } = err || {};
                    console.log(message);
                    logUI('MBHWeb.UI.PreVisitTest.GetDevices.onError', new Date(), Tools.getURLPath(), { "Error": err });
                });
        } else if (selectedAction === "8") {
            // I HAVE SPEAKERS

            this.setState({
                botResponseId: 8,
                userActionId: 8
            });
        } else if (
            selectedAction === "9" ||
            selectedAction === "61" ||
            selectedAction === "64"
        ) {
            // DONT HAVE SPEAKERS

            this.setState({
                botResponseId: 12,
                userActionId: 12
            });
        } else if (selectedAction === "10") {
            // SPEAKERS ARE MUTED

            this.setState({
                botResponseId: 9,
                userActionId: 9
            });
        } else if (selectedAction === "11") {
            // SPEAKERS ARE TURNED OFF

            this.setState({
                botResponseId: 36,
                userActionId: 36,
                playing: true
            });
        } else if (selectedAction === "12") {
            // UNMUTE SPEAKERS

            this.setState({
                botResponseId: 10,
                userActionId: 10,
                playing: true
            });
        } else if (selectedAction === "13" || selectedAction === "15") {
            // VOLUME ON SPEAKERS

            this.setState({
                botResponseId: 37,
                userActionId: 37,
                playing: false
            });
        } else if (selectedAction === "18") {
            this.setState({
                botResponseId: 39,
                userActionId: 39,
                playing: true
            });
        } else if (selectedAction === "19") {
            // DONT HAVE HEADPHONES

            this.setState({
                botResponseId: 13,
                userActionId: 13,
                playing: false
            });
        } else if (selectedAction === "22") {
            // GET PERMISSION to access WebCam and Mic.
            this.setState({ showSpinner: true });
            ensureMediaPermissions()
                .then(() => {
                    this.setState({
                        botResponseId: 20,
                        userActionId: 18,
                        showSpinner: false
                    });
                })
                .catch((err) => {
                    this.setState({ showSpinner: false });
                    const { message } = err;
                    logUI('MBHWeb.UI.PreVisitTest.EnsureMediaPermission.onError', new Date(), Tools.getURLPath(), { "Error": err });
                    if (message && message.indexOf("Permission") > -1)
                        this.setState({
                            botResponseId: 21,
                            userActionId: 21
                        });
                });
        } else if (selectedAction === "23") {
            //SKIP CLICK WHEN MICROPHONE NOT FOUND
            this.skipMic = true;
            this.setState({
                botResponseId: 18,
                userActionId: 18
            });
        } else if (selectedAction === "26") {
            // I DONT HAVE WEBCAM

            this.setState({
                botResponseId: 17,
                userActionId: 17
            });
        } else if (selectedAction === "30" || selectedAction === "31")
            // OKAY CLICK OF MIC and Webcam AND TRY AGAIN CLICK
            this.setState({
                botResponseId: 14,
                userActionId: 14
            });
        else if (selectedAction === "33") {
            // VIDEO FEED VISIBLE
            this.setState({
                botResponseId: 23,
                userActionId: 22
            });
            if (typeof currentStream !== "undefined") {
                this.stopMediaTracks(currentStream);
            }
        } else if (selectedAction === "34") {
            // VIDEO FEED NOT VISIBLE
            this.setState({
                botResponseId: 24,
                userActionId: null
            });
            if (typeof currentStream !== "undefined") {
                this.stopMediaTracks(currentStream);
            }
        } else if (selectedAction === "35" || selectedAction === "40") {
            //DONE CLICK AFTER CHANGING CAMERA
            this.setState({
                botResponseId: 22,
                userActionId: 23
            });
        } else if (selectedAction === "41") {
            // NOTHING IS THERE CLICK
            this.setState({
                botResponseId: 28,
                userActionId: 28
            });
        } else if (
            selectedAction === "2" ||
            selectedAction === "3" ||
            selectedAction === "21" ||
            selectedAction === "24" ||
            selectedAction === "28" ||
            selectedAction === "36" ||
            selectedAction === "37" ||
            selectedAction === "38" ||
            selectedAction === "39" ||
            selectedAction === "42" ||
            selectedAction === "43" ||
            selectedAction === "44" ||
            selectedAction === "45" ||
            selectedAction === "55" ||
            selectedAction === "57" ||
            selectedAction === "58"
        ) {
            if (this.props && this.props.history) {
                //debugger;
                this.props.history.push("/");
            }
        } else if (selectedAction === "50") {
            // mic test failed, is mic on - yes
            this.setState({
                botResponseId: 32,
                userActionId: 32
            });
        } else if (selectedAction === "51") {
            // mic test failed, is mic on - no
            this.setState({
                botResponseId: 33,
                userActionId: 33
            });
        } else if (selectedAction === "52") {
            // mic test failed, is mic muted - yes
            this.setState({
                botResponseId: 34,
                userActionId: 34
            });
        } else if (selectedAction === "53") {
            // mic test failed, is mic muted - no
            this.setState({
                botResponseId: 35,
                userActionId: 35
            });
        } else if (selectedAction === "54" || selectedAction === "56") {
            // mic test failed, is mic on - no - try again || is mic muted - yes - try again
            this.setState({
                botResponseId: 14,
                userActionId: 14
            });
        }
        else if (selectedAction === "60") {
            this.setState({
                botResponseId: 9,
                userActionId: 9,
                playing: false
            });
        }
        else if (selectedAction === "62")
            this.setState({ botResponseId: 38, userActionId: 38, playing: true });
        else if (selectedAction === "66")
            this.setState({ botResponseId: 40, userActionId: 40, playing: false });
        else if (selectedAction === "67")
            this.setState({ botResponseId: 42, userActionId: 42, playing: true });
        else if (selectedAction === "68")
            this.setState({ botResponseId: 41, userActionId: 41 });
        else if (selectedAction === "70")
            this.setState({ botResponseId: 41, userActionId: 41, playing: false });
    };

    stopMediaTracks = (stream) => {
        stream.getTracks().forEach((track) => {
            track.stop();
        });
    };

    onChange = (isSelected, option) => {
        if (option.id && this.state.selectedOptionId !== option.id)
            this.setState({ selectedOptionId: option.id, selectedOption: option });
    };

    onNextClick = () => {
        if (this.state.selectedOption && this.state.selectedOptionId) {
            switch (this.state.selectedOptionId) {
                case "msg-241": {
                    this.setState({
                        botResponseId: 25,
                        userActionId: 25
                    });
                    break;
                }
                case "msg-242": {
                    this.setState({
                        botResponseId: 26,
                        userActionId: 26
                    });
                    break;
                }
                case "msg-243": {
                    this.setState({
                        botResponseId: 27,
                        userActionId: 27
                    });
                    break;
                }
                case "msg-244": {
                    this.setState({
                        botResponseId: 28,
                        userActionId: 28
                    });
                    break;
                }
            }
        }
    };
    render() {
        const { botResponseId, userActionId, selectedOptionId, showSpinner } = this.state;
        const botResponse = this.config.botResponse[botResponseId]
            ? this.config.botResponse[botResponseId]
            : [];
        const userAction = userActionId ? this.config.userAction[userActionId] : [];

        return (
            <div className={`container-fluid body-content logged-out-container previsit-test-container`}>
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row previsit-container">
                            <div className="col-12 previsit-header">
                                <div className="logo">
                                    <img src="/images/mybswlogo.svg" alt="Baylor Scott & White Health logo" />
                                </div>
                            </div>
                            <div className="col-12 previsit-body">
                                {botResponse &&
                                    !botResponse[0].select &&
                                    botResponse.map((action) => (
                                        <p className="content-top" key={action.id}>
                                            {" "}
                                            {action.message}{" "}
                                        </p>
                                    ))}

                                {botResponse &&
                                    botResponse[0] &&
                                    botResponse[0].select &&
                                    botResponse[0].options && (
                                        <React.Fragment>
                                            <p className="content-top"> What do you see? </p>
                                            <div className="row">
                                                <div className="col-12">
                                                    <ul>
                                                        {botResponse[0].options.map((option, index) => (
                                                            <li key={index}>
                                                                <label className="radio-btn-container">
                                                                    <input
                                                                        type="radio"
                                                                        name={option.id}
                                                                        checked={option.id === selectedOptionId}
                                                                        onChange={(e) =>
                                                                            this.onChange(e.target.checked, option)
                                                                        }
                                                                    />
                                                                    <span className="radio-btn" />
                                                                    <span className="radio-btn-label">
                                                                        {option.message}
                                                                    </span>
                                                                </label>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>

                                        </React.Fragment>
                                    )}

                                {userActionId === 23 && (
                                    <video
                                        id="previsittest-video"
                                        autoPlay
                                        playsInline
                                        style={{ width: "200px", height: "200px" }}
                                    />
                                )}

                            </div>
                            <div className="col-12 previsit-footer">
                                <div className="row">
                                    {botResponse &&
                                        botResponse[0] &&
                                        botResponse[0].select &&
                                        botResponse[0].options
                                        ? <div className="col-12 text-center">
                                            <button className="btn btn-primary" disabled={!this.state.selectedOptionId} onClick={this.onNextClick}>
                                                NEXT
                                                </button>
                                        </div>
                                        : <React.Fragment>
                                            {showSpinner
                                                ? <div className="col-12 align-self-center"><MiniSpinner /></div>
                                                : userAction.map((action) => (
                                                    <div key={action.id} className={`col text-center`}>
                                                        {action.aTag && action.url ? <a className="btn btn-primary" href={action.url} target="_blank">{action.buttonText}</a>
                                                            : <button
                                                                className="btn btn-primary"
                                                                disabled={action.disabled}
                                                                onClick={() => {
                                                                    this.onUserAction(action);
                                                                }}
                                                            >
                                                                {" "}
                                                                {action.buttonText}{" "}
                                                            </button>
                                                        }
                                                    </div>
                                                ))

                                            }
                                        </React.Fragment>

                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
};
const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.domain.li
    };
};

export default connect(mapStateToProps, null)(PreVisitTest);